import { Validators } from '@biteinc/common';
export const addressSchema = {
    displayName: 'Full Civic Address',
    type: 'object',
    fields: {
        line1: {
            displayName: 'Line 1',
            type: 'keyString',
            required: true,
            validationRegex: Validators.addressLineRegex,
        },
        line2: {
            displayName: 'Line 2',
            type: 'keyString',
            validationRegex: Validators.addressLineRegex,
        },
        crossStreet: {
            displayName: 'Cross Street',
            type: 'keyString',
            validationRegex: Validators.simpleStringRegexString({
                allowCommas: true,
                specialCharacters: `@&#,'()/`,
                allowDiacritics: true,
            }),
        },
        city: {
            type: 'keyString',
            required: true,
            validationRegex: Validators.addressLineRegex,
        },
        state: {
            type: 'keyString',
            required: true,
            validationRegex: Validators.simpleStringRegexString(),
        },
        postalCode: {
            displayName: 'Postal Code',
            type: 'keyString',
            required: true,
            validationRegex: Validators.postalCodeRegexString,
        },
        country: {
            type: 'keyString',
            validationRegex: Validators.simpleStringRegexString(),
        },
    },
};
//# sourceMappingURL=address_schema.js.map